import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { HomesFacade } from '@library/store/homes/homes.facade';
import { PageLoaderFacade } from '@library/store/page-loader/page-loader.facade';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { LangPipe } from '@library/utils/pipes/lang.pipe';
import { HeaderService } from '@library/utils/services/header.service';

@Component({
  selector: 'app-timezone-view',
  templateUrl: './timezone-view.component.html',
  styleUrls: ['./timezone-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TimezoneViewComponent implements OnInit {
  home$ = this.homesFacade.currentHome$.pipe(isDefined());

  constructor(
    private readonly pageLoaderFacade: PageLoaderFacade,
    private readonly homesFacade: HomesFacade,
    private readonly header: HeaderService,
    private readonly langPipe: LangPipe,
    private readonly titleService: Title,
  ) {
  }

  ngOnInit(): void {
    this.pageLoaderFacade.handlePageLoader();
    this.header.push({
      title: this.langPipe.transform('common-app.__COM_SETTINGS_TIMEZONE'),
    });
    this.titleService.setTitle('Home advanced settings / Timezone');
  }
}
